import { getAuthenticatedAxiosInstance, authService } from '@stonelog/stonelog-auth-components';
import { notification } from 'antd';

class HTTP {
    get authenticated() {
        const axios = getAuthenticatedAxiosInstance();
        axios.defaults.timeout = 120000;
        axios.defaults.timeoutErrorMessage = 'Request timed out';

        axios.interceptors.response.use(
            (response) => response,
            (error) => {
                console.error(error);
                if (String(error).includes('timed out')) {
                    notification.error({
                        message: 'Ops, o servidor demorou muito para responder...',
                        description: 'Tente novamente em alguns instantes.',
                        duration: 15,
                    });
                }
                if (error?.response?.status === 401) {
                    try {
                        authService.logout();
                    } catch (newError) {
                        console.error(newError);
                    } finally {
                        authService.storage.clearCredentials();
                        window.location.reload();
                    }
                }
                throw error;
            }
        );

        return axios;
    }
}

const http = new HTTP();

export default http;
